/// <amd-module name="Wit/UI/Components/WorkItemGridCell/WorkItemGridCell.Props" />
import { IWorkItemTrackingDataProvider } from "Wit/UI/Data";
import { WorkItem, FieldType } from "Wit/Clients/Wit/Contracts/WorkItemTracking";

export interface IWorkItemGridCellProps {

    workItem: WorkItem | null;

    /**
     * WIT data provider.
     */
    dataProvider: IWorkItemTrackingDataProvider;

    /**
     * Name of work item field to render in the cell.
     */
    fieldName: string;

    /**
     * Type of work item field to render in the cell.
     */
    fieldType: FieldType | undefined;
}